function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.66663 8.33333C4.66663 5.38781 7.05444 3 9.99996 3C12.9455 3 15.3333 5.38781 15.3333 8.33333C15.3333 10.1997 14.4503 11.9789 13.3449 13.4674C12.244 14.9497 10.9607 16.0924 10.2463 16.6755C10.0993 16.7954 9.90062 16.7954 9.75359 16.6755C9.03919 16.0924 7.75588 14.9497 6.65505 13.4674C5.54959 11.9789 4.66663 10.1997 4.66663 8.33333ZM9.99996 2C6.50216 2 3.66663 4.83553 3.66663 8.33333C3.66663 10.507 4.68788 12.4958 5.85223 14.0636C7.02122 15.6377 8.37331 16.8397 9.12131 17.4502C9.63635 17.8705 10.3636 17.8705 10.8786 17.4502C11.6266 16.8397 12.9787 15.6377 14.1477 14.0636C15.312 12.4958 16.3333 10.507 16.3333 8.33333C16.3333 4.83553 13.4978 2 9.99996 2ZM9.99996 10.8333C11.3807 10.8333 12.5 9.71405 12.5 8.33333C12.5 6.95262 11.3807 5.83333 9.99996 5.83333C8.61925 5.83333 7.49996 6.95262 7.49996 8.33333C7.49996 9.71405 8.61925 10.8333 9.99996 10.8333Z",
  fill: "#676773"
});

var SvgPinOutlined = function SvgPinOutlined(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPinOutlined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin_outlined.c6539c13.svg";
export { ForwardRef as ReactComponent };